import {
  CompositionSocialUploadItemDto,
  CompositionSocialUploadsResponseDto,
} from '@app/modules/compose/composition.types';
import { useWebAppGetCompositionsDetailSocialUploads } from '@mi-front/api-v2';

/** Stable empty map when there is no data, to avoid unnecessary re-renders. */
const EMPTY_UPLOADS_BY_PLATFORM = new Map<string, CompositionSocialUploadItemDto[]>();

/**
 * Maps BFF composition social-uploads response to uploads grouped by platform id (uppercase).
 */
function selectUploadsByPlatform(
  raw: CompositionSocialUploadsResponseDto | undefined,
): Map<string, CompositionSocialUploadItemDto[]> {
  if (!raw?.uploads?.length) return EMPTY_UPLOADS_BY_PLATFORM;
  const map = new Map<string, CompositionSocialUploadItemDto[]>();
  for (const upload of raw.uploads) {
    const platform = upload.platform.toUpperCase();
    const list = map.get(platform) ?? [];
    list.push(upload);
    map.set(platform, list);
  }
  return map;
}

/**
 * Fetches composition social uploads and groups them by platform (React Query `select`).
 */
export function useCompositionSocialUploadsQuery(compositionId: string | undefined) {
  return useWebAppGetCompositionsDetailSocialUploads(compositionId ?? '', {
    query: {
      enabled: !!compositionId,
      select: selectUploadsByPlatform,
    },
  });
}
